import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/helper/ApiHelper';
import { DateTime } from 'luxon';
import { useSelector } from 'react-redux';
import { Employees } from '@/types/Employee/Employee';

interface GetEmployeesParams {
  affiliate_id?: number;
}

const getEmployees = async ({ affiliate_id }: GetEmployeesParams): Promise<Employees> => {
  const response = await apiRequest({
    url: '/api/shift/overview',
    method: 'POST',
    data: {
      affiliate_id,
      timezone: DateTime.now().toFormat('z'),
    },
  });
  return response as Employees;
};

export const useEmployees = () => {
  const selectedAffiliate = useSelector((state: any) => state.affiliate.selectedAffiliate);

  const { data, isLoading, error, refetch } = useQuery<Employees, Error>({
    queryKey: ['employees', selectedAffiliate?.id],
    queryFn: () => getEmployees({ affiliate_id: selectedAffiliate.id }),
    enabled: !!selectedAffiliate?.id, // Nur laden, wenn eine ID vorhanden ist
  });

  return {
    employees: data || {},
    isLoading,
    error,
    refetch, // Falls du manuell neu laden möchtest
  };
};
